/**
 * Get speaker from brightspot
 *
 */
import { gql } from '@apollo/client'
import { getIsLowBandwidth } from '../../hooks/useIsLowBandwidth'

const imageHeight = getIsLowBandwidth() ? 250 : 360
const imageWidth = getIsLowBandwidth() ? 250 : 500

export const speakerGQLQuery = (path) => {
  const profilePhotoSize = getIsLowBandwidth() ? 350 : 700

  return gql(`
    {
      RootsTechPageEntry(id: "${path}") {
        ... on Creator {
          biography
          businessWebsite
          name
          contentId
          title
          twitter {
            target
            url
          }
          linkedIn {
            target
            url
          }
          instagram {
            target
            url
          }
          whatsApp {
            target
            url
          }
          facebook {
            target
            url
          }
          youtube {
            target
            url
          }
          profilePhoto {
            custom(height: ${profilePhotoSize}, width: ${profilePhotoSize}, crop:true) {
              image {
                src
              }
            }
          }
          submissions {
            contentUUID
            url
            type
            title
            variant
            objectTypeId
            image {
            custom(height: ${imageHeight}, width: ${imageWidth}, crop:true) {
              image {
                src
                }
              }
            }
            creators {
              profilePhoto {
                custom(height: ${imageHeight}, width: ${imageWidth}, crop:true) {
                  image {
                    src
                  }
                }
              }
            }
          }
        }
      }
    }
  `)
}

export const speakerByIdGQLQuery = (id) => {
  return gql(`
    {
      RootsTechSearchPage(id: "/dosearch", contentIds: "${id}") {
        results {
          url
          title
          contentUUID
          image {
            image {
              src
            }
          }
        }
      }
    }
  `)
}

export const dummy = () => {}
